import { render, staticRenderFns } from "./SearchResultOffload.vue?vue&type=template&id=150aad54&scoped=true"
import script from "./SearchResultOffload.vue?vue&type=script&lang=js"
export * from "./SearchResultOffload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150aad54",
  null
  
)

export default component.exports